import { useEffect, useMemo, useReducer, useState } from 'react';
import { useSelector } from 'react-redux';
import { PAGE_SIZES } from '../../../contants/pageSizes';

export const usePagination = (params = {}) => {
  const { tabFromParent, statusCampaign, debouncedSearchTerm } = params;

  const {
    setCampaignsTab: tabFromRedux,
    choosenSources,
    choosenCampaigns,
  } = useSelector(state => state.createBudget);
  const currentTab = tabFromParent ?? tabFromRedux;

  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);

  const [dataPaginationCampaignTab, setDataPaginationCampaignTab] = useReducer(
    (prevState, newState) => ({
      ...prevState,
      ...newState,
    }),
    {
      currentPage: 1,
      totalItems: 0,
    },
  );

  const [dataPaginationAccountTab, setDataPaginationAccountTab] = useReducer(
    (prevState, newState) => ({
      ...prevState,
      ...newState,
    }),
    {
      currentPage: 1,
      totalItems: 0,
    },
  );

  useEffect(() => {
    setDataPaginationAccountTab({ currentPage: 1 });
    setDataPaginationCampaignTab({ currentPage: 1 });
  }, [pageSize]);

  useEffect(() => {
    setPageSize(PAGE_SIZES[0]);
    setDataPaginationAccountTab({ currentPage: 1 });
    setDataPaginationCampaignTab({ currentPage: 1 });
  }, [
    choosenSources,
    choosenCampaigns,
    currentTab,
    statusCampaign,
    debouncedSearchTerm,
  ]);

  const handleChangeSelectPageSize = option => {
    setPageSize(option);
  };

  const handlePageChange = page => {
    if (currentTab === 'accounts') {
      setDataPaginationAccountTab({ currentPage: page });
    } else if (currentTab === 'campaigns') {
      setDataPaginationCampaignTab({ currentPage: page });
    }
  };

  const { totalItems, currentPage } = useMemo(() => {
    if (currentTab === 'accounts') {
      return {
        totalItems: dataPaginationAccountTab.totalItems,
        currentPage: dataPaginationAccountTab.currentPage,
      };
    }
    if (currentTab === 'campaigns') {
      return {
        totalItems: dataPaginationCampaignTab.totalItems,
        currentPage: dataPaginationCampaignTab.currentPage,
      };
    }
    return { totalItems: 0, currentPage: 1 };
  }, [currentTab, dataPaginationAccountTab, dataPaginationCampaignTab]);

  return {
    dataPaginationAccountTab,
    dataPaginationCampaignTab,
    pageSize,
    currentPage,
    totalItems,
    setDataPaginationAccountTab,
    setDataPaginationCampaignTab,
    handleChangeSelectPageSize,
    handlePageChange,
  };
};
